import PropTypes from 'prop-types';
import React from 'react';
import { Button, ButtonGroup } from 'react-bootstrap';

export class AppointmentFilterButtonGroup extends React.Component {
  renderButtons = () =>
    ((this.props.filterConfig) ? this.props.filterConfig.map(filterConfigItem =>
      (<div className="btn-group" role="group" key={filterConfigItem.filterValue}>
          <Button
            ref={filterConfigItem.filterValue + 'button'}
            onClick={this.props.handleClickEvent}
            value={filterConfigItem.filterValue}
            active={filterConfigItem.filterValue === this.props.value}
          >
            {filterConfigItem.filterTitle}
          </Button>
       </div>)
    ) : []);

  render() {
    return (
      <ButtonGroup
        className="btn-group-justified"
        role="group"
        id={this.props.id}
      >
        {this.renderButtons()}
      </ButtonGroup>
    );
  }
}

AppointmentFilterButtonGroup.propTypes = {
  handleClickEvent: PropTypes.func,
  filterConfig: PropTypes.array,
  value: PropTypes.string,
  id: PropTypes.string,
};
